import {INITIAL_LOAD_STATUS_SUBSTATE, LoadStatusSubstate} from '@aviary/store/store.types';
import {Hold, ReadyForPickupHolds} from '@store/holds/holds.types';
import {ActionReducer, createReducer, on} from '@ngrx/store';
import {FAILED, LOADED, LOADING} from '@aviary/store/common/common.types';
import {HoldsActions} from './holds.actions';
import {PatronActions} from '@store/patron/patron.actions';

export interface HoldsState {
  readyForPickup: LoadStatusSubstate & {
    data?: ReadyForPickupHolds;
  };
  onHold: LoadStatusSubstate & {
    data: Hold[];
  };
  holdsForCatalogRecords: LoadStatusSubstate & {
    data: Hold[];
  };

  dependentReadyForPickup: LoadStatusSubstate & {
    data?: ReadyForPickupHolds;
  };
  dependentOnHold: LoadStatusSubstate & {
    data: Hold[];
  };
}

export const INITIAL_HOLDS_STATE: HoldsState = {
  readyForPickup: {
    ...INITIAL_LOAD_STATUS_SUBSTATE,
    data: undefined
  },
  onHold: {
    ...INITIAL_LOAD_STATUS_SUBSTATE,
    data: [],
  },
  holdsForCatalogRecords: {
    ...INITIAL_LOAD_STATUS_SUBSTATE,
    data: [],
  },
  dependentReadyForPickup: {
    ...INITIAL_LOAD_STATUS_SUBSTATE,
    data: undefined
  },
  dependentOnHold: {
    ...INITIAL_LOAD_STATUS_SUBSTATE,
    data: [],
  },
};

export const holdsState: ActionReducer<HoldsState> = createReducer(
  INITIAL_HOLDS_STATE,
  on(HoldsActions.loadReadyForPickupHolds, state => ({
    ...state,
    readyForPickup: {
      ...state.readyForPickup,
      loadStatus: LOADING
    }
  })),
  on(HoldsActions.loadReadyForPickupHoldsSuccess, (state, {data}) => ({
    ...state,
    readyForPickup: {
      ...state.readyForPickup,
      loadStatus: LOADED,
      data
    }
  })),
  on(HoldsActions.loadReadyForPickupHoldsFailure, state => ({
    ...state,
    readyForPickup: {
      ...INITIAL_HOLDS_STATE.readyForPickup,
      loadStatus: FAILED,
    }
  })),

  on(HoldsActions.loadOnHoldHolds, state => ({
    ...state,
    onHold: {
      ...state.onHold,
      loadStatus: LOADING
    }
  })),
  on(HoldsActions.loadOnHoldHoldsSuccess, (state, {listData: {data}}) => ({
    ...state,
    onHold: {
      ...state.onHold,
      loadStatus: LOADED,
      data
    }
  })),
  on(HoldsActions.loadOnHoldHoldsFailure, state => ({
    ...state,
    onHold: {
      ...INITIAL_HOLDS_STATE.onHold,
      loadStatus: FAILED,
    }
  })),

  on(HoldsActions.loadHoldsForCatalogRecords, state => ({
    ...state,
    holdsForCatalogRecords: {
      ...state.holdsForCatalogRecords,
      loadStatus: LOADING
    }
  })),
  on(HoldsActions.loadHoldsForCatalogRecordsSuccess, (state, {holds}) => ({
    ...state,
    holdsForCatalogRecords: {
      ...state.holdsForCatalogRecords,
      loadStatus: LOADED,
      data: holds
    }
  })),
  on(HoldsActions.loadHoldsForCatalogRecordsFailure, state => ({
    ...state,
    holdsForCatalogRecords: {
      ...INITIAL_HOLDS_STATE.holdsForCatalogRecords,
      loadStatus: FAILED,
    }
  })),

  on(PatronActions.loadDependentReadyForPickupHolds, state => ({
    ...state,
    dependentReadyForPickup: {
      ...state.dependentReadyForPickup,
      loadStatus: LOADING
    }
  })),
  on(PatronActions.loadDependentReadyForPickupHoldsSuccess, (state, {data}) => ({
    ...state,
    dependentReadyForPickup: {
      ...state.dependentReadyForPickup,
      loadStatus: LOADED,
      data
    }
  })),
  on(PatronActions.loadDependentReadyForPickupHoldsFailure, state => ({
    ...state,
    dependentReadyForPickup: {
      ...INITIAL_HOLDS_STATE.dependentReadyForPickup,
      loadStatus: FAILED,
    }
  })),

  on(PatronActions.loadDependentOnHoldHolds, state => ({
    ...state,
    dependentOnHold: {
      ...state.dependentOnHold,
      loadStatus: LOADING
    }
  })),
  on(PatronActions.loadDependentOnHoldHoldsSuccess, (state, {listData: {data}}) => ({
    ...state,
    dependentOnHold: {
      ...state.dependentOnHold,
      loadStatus: LOADED,
      data
    }
  })),
  on(PatronActions.loadDependentOnHoldHoldsFailure, state => ({
    ...state,
    dependentOnHold: {
      ...INITIAL_HOLDS_STATE.dependentOnHold,
      loadStatus: FAILED,
    }
  })),
);
